import dayjs from 'dayjs';
import { BONUS_TRANSACTION_TYPE } from '../types';
import { t } from 'i18next';
import project from 'src/config/project.json';
import { Link } from 'react-router';
import { License } from 'src/svg/License';
import lnld from '../assets/images/lnld.webp';
import {
  Astropay,
  BankTransfer,
  Bitcoin,
  Cashtocode,
  EcoPayz,
  Ethereum,
  Ezeewallet,
  Flexepin,
  Interac,
  Jeton,
  Litecoin,
  MB,
  Neosurf,
  Neteller,
  Paysafe,
  Ripple,
  Skrill,
  Tether
} from 'src/svg/Payments';

import { isProductionEnv } from 'src/api';
import { MessageDefault, MessageError, MessageSuccess } from 'src/svg/Massages';

export const SIGN_UP_BONUS_ID = isProductionEnv ? '574' : '315';

export const bonusHeader = [
  'transactionsTable.date',
  'transactionsTable.gameName',
  'transactionsTable.amount',
  'transactionsTable.balance',
  'transactionsTable.status'
];
export const basicHeader = [
  'transactionsTable.date',
  'transactionsTable.gameName',
  'transactionsTable.amount',
  'transactionsTable.balance',
  'transactionsTable.status'
];
export const transactionHistoryHeader = [
  'transactionHistoryTable.date',
  'transactionHistoryTable.amount',
  'transactionHistoryTable.fee',
  'transactionHistoryTable.curerncy',
  'transactionHistoryTable.status'
];

export const MESSAGE_DESCRIPTION = {
  info: <MessageDefault />,
  error: <MessageError />,
  success: <MessageSuccess />
};

export const L = {
  NLD: {
    text: `${project.projectNameUppercase} is owned and operated by FGS SOFTWARE SOLUTIONS S.R.L., a company registered and established under the laws of Costa Rica. FGS SOFTWARE SOLUTIONS S.R.L. is regulated by the Government of Costa Rica. SOFTWARE SOLUTIONS S.R.L. registration number is 3-102-871832.`,
    logo: <img src={lnld} className="max-w-[65px] " alt="first license" />,
    getPageCodeFormat: (page?: string) => (page ? `${page}_jt` : undefined)
  },
  OTHERS: {
    text: `www.${project.projectName}.com is operated by Fair Game Software KFT (registration number 13-09-204926, registered under the laws of Hungary, registered address: 2161 Csomád, Kossuth Lajos út 79, is an agent of FairGame G.P. N.V ) which provides management, payment and support services related to the operation of the website. The operations of the website have been leased by the license holder FairGame G.P. N.V. (registration number 141938, address Abraham de Veerstraat 9, Curacao, with license number GLH-OCCHKTW0703032017 and regulated by the laws of Curacao and operates under the Master License of Gaming Services Provider, N.V. #365/JAZ as an Information Service Provider) to Fair Game Software KFT.`,
    logo: (
      <Link
        to="https://licensing.gaming-curacao.com/validator/?lh=21c0bec8198be1c2d52fe40bb0af4961"
        target="_blank">
        <License className="max-w-[100px]" />
      </Link>
    ),
    getPageCodeFormat: (page?: string) => page
  }
};

export const paymentsCards = [
  // {
  //   name: 'Visa',
  //   image: <Visa />
  // },
  // {
  //   name: 'Mastercard',
  //   image: <Mastercard />
  // },
  {
    name: 'Skrill',
    image: <Skrill fill="var(--f_icons)" />
  },
  {
    name: 'Neteller',
    image: <Neteller fill="var(--f_icons)" />
  },
  {
    name: 'Ezeewallet',
    image: <Ezeewallet fill="var(--f_icons)" />
  },
  {
    name: 'Neosurf',
    image: <Neosurf fill="var(--f_icons)" />
  },
  {
    name: 'Astropay',
    image: <Astropay fill="var(--f_icons)" />
  },
  {
    name: 'Flexepin',
    image: <Flexepin fill="var(--f_icons)" />
  },
  {
    name: 'Cashtocode',
    image: <Cashtocode fill="var(--f_icons)" />
  },
  {
    name: 'Interac',
    image: <Interac fill="var(--f_icons)" />
  },
  {
    name: 'Jeton',
    image: <Jeton fill="var(--f_icons)" />
  },
  {
    name: 'MB',
    image: <MB fill="var(--f_icons)" />
  },
  {
    name: 'EcoPayz',
    image: <EcoPayz fill="var(--f_icons)" />
  },
  {
    name: 'BankTransfer',
    image: <BankTransfer fill="var(--f_icons)" />
  },
  {
    name: 'Paysafe',
    image: <Paysafe fill="var(--f_icons)" />
  },
  {
    name: 'Ripple',
    image: <Ripple fill="var(--f_icons)" />
  },
  {
    name: 'Bitcoin',
    image: <Bitcoin fill="var(--f_icons)" />
  },
  {
    name: 'Ethereum',
    image: <Ethereum fill="var(--f_icons)" />
  },
  {
    name: 'Litecoin',
    image: <Litecoin fill="var(--f_icons)" />
  },
  {
    name: 'Tether',
    image: <Tether fill="var(--f_icons)" />
  }
  // {
  //   name: 'IdentityVerification',
  //   image: <IdentityVerification fill="var(--f_icons)" />
  // }
];

const arrayTransactions = [
  `${t('arrayTransactions.deposit')}`,
  `${t('arrayTransactions.withdraw')}`,
  `${t('arrayTransactions.bet')}`,
  `${t('arrayTransactions.win')}`,
  `${t('arrayTransactions.bonus')}`,
  `${t('arrayTransactions.jackpot')}`,
  `${t('arrayTransactions.changeBalanceInc')}`,
  `${t('arrayTransactions.changeBalanceDec')}`,
  `${t('arrayTransactions.referral')}`,
  `${t('arrayTransactions.convertBalance')}`,
  `${t('arrayTransactions.moneyPrize')}`,
  `${t('arrayTransactions.bonusTransaction')}`,
  `${t('arrayTransactions.cancelBonusFine')}`,
  `${t('arrayTransactions.refund')}`,
  `${t('arrayTransactions.rollbackBet')}`,
  `${t('arrayTransactions.betSport')}`,
  `${t('arrayTransactions.jackpotIncreasing')}`,
  `${t('arrayTransactions.levelBonus')}`
];

import { GameCardBannerType } from 'src/components/GameCard/components/GameCardBanner';

export const months = (language: string) => {
  dayjs.locale(language);
  return dayjs.monthsShort().map((elem, index) => ({
    name: elem,
    id: String(index + 1),
    value: String(index + 1)
  }));
};

export const days = new Array(31).fill(null).map((_, i) => {
  return { name: `${i + 1}`, id: String(`${i + 1}`), value: `${i + 1}` };
});

const currentYear = new Date().getFullYear();

export const years = new Array(100).fill(null).map((_, i) => {
  return {
    name: `${currentYear - 18 - i}`,
    id: String(`${currentYear - 18 - i}`),
    value: `${currentYear - 18 - i}`
  };
});

export const transactionTypesOptions = arrayTransactions.map((element, index) => {
  return { name: element, id: String(index + 1) };
});

export const IconCurrency = {
  EUR: '€',
  USD: '$',
  RUB: '₽',
  FS: 'FS',
  JPY: '¥',
  CHF: 'CHF',
  AUD: 'AU$',
  CAD: 'C$',
  PLN: 'zł',
  NOK: 'kr',
  NZD: 'NZ$',
  DKK: 'kr',
  BRL: 'R$',
  SEK: 'kr',
  INR: '₹'
};

export const bonusTransactionsOptions = BONUS_TRANSACTION_TYPE.map((transaction, index) => ({
  id: `${index}`,
  name: t(`${transaction}`)
}));

export enum ScreenModes {
  Desktop,
  Mobile
}

export const SCREEN_MODE = ScreenModes.Mobile;

export const bonusQueue = [
  `${t('tableBonusQueue.name')}`,
  `${t('tableBonusQueue.amount')}`,
  `${t('tableBonusQueue.maxBet')}`,
  `${t('tableBonusQueue.wager')}`,
  `${t('tableBonusQueue.date')}`
];

export const sortType = [
  { id: 'amountAsc', name: 'sortType.amountUp', sort: 'amount', sortDir: 'asc' },
  { id: 'amountDesc', name: 'sortType.amountDown', sort: 'amount', sortDir: 'desc' },
  { id: 'dateAsc', name: 'sortType.dateUp', sort: 'date', sortDir: 'asc' },
  { id: 'dateDesc', name: 'sortType.amountUp', sort: 'date', sortDir: 'desc' }
];

export const categoryBadgeGame = {
  1: {
    id: 1,
    type: GameCardBannerType.NEW,
    title: 'categoryBadgeGame.new',
    style: 'game-1'
  },
  2: {
    id: 2,
    type: GameCardBannerType.TOP,
    title: 'categoryBadgeGame.top',
    style: 'background-10'
  }
};

export const BONUS_TYPE = {
  0: {
    name: 'Registration',
    content: 'bonusType.registration'
  },
  1: {
    name: 'RegistrationPromoCode',
    content: 'bonusType.registrationPromoCode'
  },
  2: {
    name: 'FirstAuthorization',
    content: 'bonusType.firstAuthorization'
  },
  3: {
    name: 'PromoCode',
    content: 'bonusType.promoCode'
  },
  4: {
    name: 'Birthday',
    content: 'bonusType.birthday'
  },
  5: {
    name: 'Deposits',
    content: 'bonusType.deposits'
  },
  6: {
    name: 'Periodic',
    content: 'bonusType.periodic'
  },
  7: {
    name: 'IncreaseWinnings',
    content: 'bonusType.increaseWinnings'
  },
  8: {
    name: 'ActivatedByLink',
    content: 'bonusType.activatedByLink'
  }
};

export const contentGamesPageCodes = {
  megaways: 'megaways',
  'fruits-games': 'fruit',
  books: 'book',
  dropwins: 'drops_win',
  aviator: 'aviator'
};

export const paginationDots = '...';
export const siblingCount = 1;
export const totalPageNumbers = siblingCount + 5;
export const leftItemCount = 4;
export const rightItemCount = 4;

export const arrayFromRange = (start: number, end: number): number[] => {
  const length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};

export const isPwa = window.matchMedia('(display-mode: standalone)').matches;

// Должен точно дублировать текущий tailwind config
export const BP = {
  // MOBILE
  M_XS: 320,
  M_SM: 360,
  M_MD: 375,
  M_LG: 412,

  // TABLET
  T_XS: 568,
  T_SM: 640,
  T_MD: 768,

  // DEKSTOP
  XGA: 1024,
  HD: 1280,
  QHD: 1440,
  FULL_HD: 1920,
  WQHD: 2560
};

export const PROVIDER_ID_SEARCH_PARAM = 'providerId';

export const GAMES_SEARCH_SYMBOLS_THRESOLD = 2;
export const PROVIDER_SEARCH_SYMBOLS_THRESOLD = 1;

export const MIN_USER_BALANCE_VALUE = 100;
export const ONE_MINUTE_MS = 60000;

export const SHORT_BALANCE_REFETCH_INTERVAL = 3000;

export const CACHE_TIME_2000 = { cacheTime: 2000, staleTime: 2000 };

export const THREE_SECONDS = 3000;
export const FIFTEEN_SECONDS = 15000;

export const EMAIL_SEARCH_PARAM = 'email';
export const AUTH_EMAIL_SS_KEY = 'email';

export const REFFERAL_BONUS_TAG = 'referal';
